export default {
    collaborators: undefined,
    filteredCollaborators: undefined,
    collaboratorsOptions: [],
    loading: false,
    error: null,
    errorShow: false
}